/**
 * Utility functions for managing recent email subject lines in localStorage
 * This allows merchants to reuse commonly used subject lines without affecting
 * the global emailSubject setting (which would apply to all automatic checks)
 */

const STORAGE_KEY = 'real_id_recent_email_subjects';
const MAX_SUBJECTS = 5;

/**
 * Get the list of recently used email subjects from localStorage
 * @returns {Array<string>} Array of recent subject lines, newest first
 */
export const getRecentSubjects = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error reading recent subjects from localStorage:', error);
    return [];
  }
};

/**
 * Save a subject line to the recent history
 * Removes duplicates and maintains max count
 * @param {string} subject - The subject line to save
 */
export const saveSubjectToHistory = (subject) => {
  // Don't save empty or default-looking subjects
  if (!subject || subject.trim() === '') {
    return;
  }

  try {
    const recent = getRecentSubjects();
    
    // Remove any existing duplicate and add to front
    const filtered = recent.filter(s => s !== subject);
    const updated = [subject, ...filtered].slice(0, MAX_SUBJECTS);
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (error) {
    console.error('Error saving subject to localStorage:', error);
  }
};

/**
 * Clear all recent subjects from history
 */
export const clearSubjectHistory = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing subject history:', error);
  }
};